import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Box, Menu, UserAvatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { useGetLinks } from 'shared/domains/urls';
import { useAccount } from 'shared/domains/users';
export function AccountInfoSection() {
    var _a, _b;
    const account = useAccount();
    const userName = ((_a = account.data.profile) === null || _a === void 0 ? void 0 : _a.name) || '';
    const userCompany = (_b = account.data.company) === null || _b === void 0 ? void 0 : _b.name;
    const { contact } = useGetLinks();
    const handlePrivacySettingsClick = () => {
        var _a, _b;
        if (Boolean(window.UC_UI) && typeof ((_a = window.UC_UI) === null || _a === void 0 ? void 0 : _a.showSecondLayer) === 'function') {
            (_b = window.UC_UI) === null || _b === void 0 ? void 0 : _b.showSecondLayer();
        }
    };
    return (<Fragment>
      <Box pt="xl" pl="xl" pr="xl" pb="md">
        <UserAvatar size="md" title={userName} subtitle={userCompany}/>
      </Box>
      <Menu.Item onClick={handlePrivacySettingsClick}>
        <Falcon icon="arrow-up-right-from-square"/>
        <Trans comment="Privacy settings link text">Privacy settings</Trans>
      </Menu.Item>
      <Menu.Item render={<a href={contact} target="_blank" rel="noopener noreferrer">
            <Falcon icon="arrow-up-right-from-square"/>
            <Trans comment="User account menu: Contact support link text">Contact support</Trans>
          </a>}/>
      <Menu.Item render={<Link to="/logout">
            <Falcon icon="sign-out"/>
            <Trans comment="User account menu: Sign out link text">Sign out</Trans>
          </Link>}/>
    </Fragment>);
}
